"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatInfoContext = void 0;
const react_1 = require("react");
exports.ChatInfoContext = (0, react_1.createContext)({});
